import React, { useEffect, useState } from 'react';
import UtilsBufer from '../Tools/UtilsBufer';
import MsgUtils from '../Tools/MsgUtils';
import CircleLoader from "react-spinners/CircleLoader";
import UtilsListas from '../Tools/UtilsListas';
import VerificarPermisos from '../Tools/VerificarPermisos';
import addButton from "../../assets/addButon.png";

const server = process.env.REACT_APP_SERVER;
function MisComunicados({ regional, setElegido, setSelectComu, tipo, setModalNuevoComunicado, setModalDetalle }) {
    const [comunicados, setComunicados] = useState([]);
    const [dateIni, setDateIni] = useState('');
    const [dateFin, setDateFin] = useState('');
    const [loading, setLoading] = useState(true);
    const [actualizar, setActualizar] = useState(false);
    const [hayC, setHayC] = useState(false);
    const formatoFecha = (fecha) => {
        let date = new Date(Date.parse(fecha));
        return `${date.getDate()}/${date.toLocaleString('default', { month: 'long' })}/${date.getFullYear()}`;
    }
    const eliminarComunicado = (e) => {
        fetch(`${server}/comunicados/eliminar/${e.target.id}/${regional}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    MsgUtils.msgCorrecto(data.ok);
                    setActualizar(!actualizar);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    const estadoMensaje = (e) => {
        console.log(e.target.id)
        if (e.target.id !== null) {
            var dato = UtilsListas.getElemento(comunicados, e.target.id);
            setSelectComu(dato);
            setModalDetalle(true);
        }
    }
    useEffect(() => {
        fetch(`${server}/comunicados/enviados`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                dateIni, dateFin, regional, info: JSON.parse(localStorage.getItem("info")), tipo
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setLoading(false);
                    setComunicados(data.ok);
                    if (data.ok.length !== 0) {
                        setHayC(true);
                    } else {
                        setHayC(false);
                    }
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }, [actualizar, regional])
    useEffect(() => {
        if (dateIni === '' && dateFin === '') {
            var fecha = new Date()
            setDateFin(fecha.toISOString().substring(0, 10));
            var fechaI = new Date(fecha.setDate(fecha.getDate() - 5))
            setDateIni(fechaI.toISOString().substring(0, 10));
            setActualizar(!actualizar);
        }
    }, [])
    return (
        <div>
            <div className='container-fluid bg-secondary text-white py-1'>
                <div className="btn-group" role="group" aria-label="Basic example">
                    <div className='row row-cols-sm-1 row-cols-md-2 g-1'>
                        <div className='col col-sm-6 col-md-6'>
                            <div className="input-group my-auto" style={{ height: "25px", width: "210px" }}>
                                <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Inicio</span>
                                <input type="date" className="form-control"
                                    aria-describedby="basic-addon1" style={{ height: "25px" }}
                                    value={dateIni} onChange={(e) => { setActualizar(!actualizar); setLoading(true); setDateIni(e.target.value); }} />
                            </div>
                        </div>
                        <div className='col col-sm-6 col-md-6'>
                            <div className="input-group my-auto" style={{ height: "25px", width: "210px" }}>
                                <span className="input-group-text bg-secondary bg-gradient text-light" style={{ height: "25px" }}>Fin</span>
                                <input type="date" className="form-control"
                                    aria-describedby="basic-addon1" style={{ height: "25px" }}
                                    value={dateFin} onChange={(e) => { setActualizar(!actualizar); setLoading(true); setDateFin(e.target.value); }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='text-center mx-auto'>
                <CircleLoader className='text-center mx-auto' color='#F95E10' loading={loading} size={200} />
            </div>
            <div className={loading === false ? '' : 'd-none'}>
                <div className={hayC ? 'd-none' : 'card bg-warning text-center'}>
                    <div className='card-header bg-gradient fw-bold'>
                        <i className="fa-solid fa-circle-info"></i> No hay {tipo === 'C' ? 'Comunicados' : 'Mensajes'}
                    </div>
                    <div className='card-body'>
                        En los rangos de fechas actuales, no se tiene {tipo === 'C' ? 'Comunicados' : 'Mensajes'} ...
                    </div>
                </div>
                <div className={hayC ? 'table-responsive' : 'd-none'}>
                    <table className="table table-striped table-bordered table-sm table-hover">
                        <thead className='bg-secondary bg-gradient text-center fw-bold text-light'>
                            <tr>
                                <th scope="col">FECHA</th>
                                <th scope="col">DE:</th>
                                <th scope="col">Descripción</th>
                                <th scope="col">OPT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comunicados.map((item) => {
                                return (
                                    <tr key={item.ID_COMUNICADO} className="my-auto">
                                        <th className="col-1">{formatoFecha(item.FECHA)}</th>
                                        <td className='col-4'>
                                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                                                {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                                <div className='ps-2 my-auto d-none d-sm-inline'>
                                                    <div className="cargoHeader fw-bold">{item.COLABORADOR}</div>
                                                    <div className='cargoHeader '>{item.CARGO}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{item.DESCRIPCION}</td>
                                        <td>
                                            <a className='btn btn-transparent fs-4 m-0 p-0' id={item.ID_COMUNICADO}
                                                onClick={estadoMensaje}>
                                                <i id={item.ID_COMUNICADO} className="bi bi-book-half"></i>
                                            </a>
                                            <a className='btn btn-transparent fs-4 m-0 p-0 text-danger px-2'>
                                                <i className="fa-solid fa-trash-can"></i>
                                            </a>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            {VerificarPermisos.validarPermiso(16)&&
            <div className={`fixed-bottom text-end m-2`}>
                <img src={addButton} height='50' onClick={() => setModalNuevoComunicado(true)}></img>
            </div>}
        </div>
    )
}

export default MisComunicados
